module.exports = __webpack_public_path__ + "static/media/login-background2-tw-as.67fa725d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background2-tw-as.png
// module id = 1099
// module chunks = 110